namespace Ir.Components.Filters.FilterSection {
    interface IViewModel {
        filters: KnockoutComputed<KnockoutObservableArray<Filter>>;
        comparisonFilters: KnockoutComputed<KnockoutObservableArray<ComparisonFilter>>;
        icon: KnockoutComputed<string>;
        iconClass: KnockoutComputed<string>;
        title: KnockoutComputed<string>;
        isToolbar: KnockoutObservable<boolean>;
        isDrilldown: KnockoutObservable<boolean>;
        scope: KnockoutComputed<ContainerScopeEnum>;
        isComparisonFilter: KnockoutObservable<boolean>;

        addFilter: DevExpress.ui.dxButton.Properties;
        clearFilters: DevExpress.ui.dxButton.Properties;
        popoverAddListOptions: DevExpress.ui.dxList.Properties;

        addClearButtonsVisible: boolean;

        addItemFilterClick: (itemData: any) => void;

        filterListParams: Ir.Components.Filters.FilterList.IFilterListParams;
        comparisonListParams: Ir.Components.Filters.ComparisonFilter.ComparisonFilterList.IComparisonFilterListParams;

        filtersDataSource: KnockoutObservableArray<any>;

        addFilterHint: KnockoutComputed<string>;
    }

    interface IParams {
        config: IFilterSectionParams
    }
    export interface IFilterSectionParams  {
        filters?: KnockoutComputed<KnockoutObservableArray<Filter>>;
        comparisonFilters?: KnockoutComputed<KnockoutObservableArray<ComparisonFilter>>;
        title: KnockoutComputed<string>;
        isToolbar: boolean;
        isDrilldown?: boolean
        scope: KnockoutComputed<ContainerScopeEnum>;
        icon?: string;
        disabled?: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
        onOrderChanged?: (filters: KnockoutObservableArray<Filter>) => void;

        addClearButtonsVisible?: boolean;
        isComparisonFilter?: boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
                
        this.filters = params.config.filters;
        this.comparisonFilters = params.config.comparisonFilters;
        
        this.title = params.config.title;
        this.isToolbar = ko.observable(params.config.isToolbar);
        this.isDrilldown = ko.observable(params.config.isDrilldown);
        this.scope = params.config.scope;

        this.isComparisonFilter = ko.observable(params.config.isComparisonFilter === undefined ? false : params.config.isComparisonFilter);
        this.icon = ko.computed(function () {
            if (params.config.icon) {
                return params.config.icon;
            }

            switch (self.scope()) {
                case ContainerScopeEnum.ComparisonFilter:
                    return "compare_arrows";
                case ContainerScopeEnum.Widget:
                    return "widgets";
                case ContainerScopeEnum.Dashboard:
                    return "dashboard";
                case ContainerScopeEnum.Report:
                    return "tab";
                case ContainerScopeEnum.Workbook:
                    return "import_contacts";
                default:
            }
        });
        this.iconClass = ko.computed(() => {
            return self.scope() === ContainerScopeEnum.Dashboard ? "mi" : "ms";
        });
        this.addFilterHint = ko.computed(() => {
            return `Add new ${(ContainerScopeEnum[self.scope()])}${(self.isDrilldown() ? " Drilldown" : "")} Filter`;
        });
        let clearFilterHint = ko.computed(() => {
            return `Clear ${(ContainerScopeEnum[self.scope()])}${(self.isDrilldown() ? " Drilldown" : "")} Filters`;
        });

        this.addClearButtonsVisible = params.config.addClearButtonsVisible === undefined ? true : params.config.addClearButtonsVisible;
        this.addFilter = {
            icon: "add",
            hint: this.addFilterHint as any,
            onClick: function (e) {
                addFilter(this, componentInfo.element, e.element, self.scope(), self.filters);
            }.bind(this),
            disabled: params.config.disabled as any || false,
            visible: this.addClearButtonsVisible
        };
        this.clearFilters = {
            icon: "clearformat",
            hint: clearFilterHint as any,
            onClick: function (e) {
                clearFilters(self.filters);
            },
            disabled: params.config.disabled as any || false,
            visible: this.addClearButtonsVisible
        };

        if (this.isComparisonFilter()) {
            this.comparisonListParams = {
                isToolbar: this.isToolbar,
                isDrilldownTab: this.isDrilldown()
            };
        }
        else {
            this.filterListParams = {
                orientation: (this.isToolbar() ? 'horizontal' : 'vertical'),
                isToolbar: this.isToolbar,
                isDrilldown: this.isDrilldown,
                onOrderChanged: params.config.onOrderChanged
            };
        }

        this.filtersDataSource = ko.observableArray([]);
        this.popoverAddListOptions = {
            dataSource: this.filtersDataSource,
            displayExpr: "name",
            keyExpr: "id",
            searchEnabled: true,
            searchExpr: ["name"],
            searchMode: "contains",
            grouped: true,
            itemTemplate(data) {
                let icon = Filter.getIcon(data.filterEditorType, data.isMetric);
                let displayName = replaceBasicHtmlContent(data.name);
                return $(`<div><span class="material-icons">${icon}</span> ${displayName}</div>`);
            },
            onItemClick(e) {
                self.addItemFilterClick(e.itemData);
            },
        };
        this.addItemFilterClick = null;
    }

    function addFilter(self: IViewModel, element: any, buttonElement: JQuery<HTMLElement>, scope: ContainerScopeEnum, filters: KnockoutComputed<KnockoutObservableArray<Filter>>) {
        self.addItemFilterClick = (itemData) => {
            let activeTabOrWidget = workbook.workbookConfig.activeTabOrWidget?.();
            let o = {
                url: urlConfigs.filters + "AddFilter",
                data: {
                    scope: scope,
                    addedFilter: itemData.isMetric ? 0 : itemData.filterTemplateId,
                    addedMetricFilter: itemData.isMetric ? itemData.metricQueryName : "",
                    isMetric: itemData.isMetric,
                    mappingId: workbook.workbookConfig.mappingId,
                    workbookId: workbook.workbookConfig.workbookId?.(),
                    tabId: workbook.workbookConfig.activeTab?.()?.id?.(),
                    drilldownId: activeTabOrWidget?.drilldownManager?.isDrilldown && self.isDrilldown() ? activeTabOrWidget.drilldownManager.activeDrilldownId : -1,
                    widgetId: workbook.workbookConfig.selectedDashboardWidget?.id?.()
                },
                dataType: "json",
                async: true,
                dontUpdateFilters: true
            } as RequestServerParams;

            let popover = $('.popover-add-filter', element).data("dxPopover");
            o.successFunction = function (data) {
                let filter = new Filter(data.filter);

                if (scope === ContainerScopeEnum.ComparisonFilter) {
                    filter.isComparisonFilter(true);
                }

                filter.isDirty(true);
                filter.added(true);
                filters().push(filter);

                if (!filter.isDrilldown()) {
                    workbook.workbookConfig.workbookHelper?.applyFiltersDisabled?.(false);
                }

                popover.hide();
            };
            o.failureFunction = function () {
                popover.hide();
            }

            irGlobal.requestServer(o);
        }

        let activeTabOrWidget = workbook.workbookConfig.activeTabOrWidget?.();

        let data = { filtersTemplate: [], metricFilters: [] };
        data.filtersTemplate = MappingService.getCurrentMapping().filters.map(x => ({
            id: x.id,
            name: x.name,
            isTemplate: true,
            filterTemplateId: x.id,
            isMetric: false,
            metricQueryName: "",
            filterEditorType: x.filterEditorType,
            boundFieldId: x.boundField,
            order: x.order
        }));

        if (scope !== ContainerScopeEnum.ComparisonFilter) {
            data.metricFilters = MappingService.getCurrentMapping().metrics.map(x => ({
                id: x.queryName,
                name: x.displayName,
                isTemplate: false,
                filterTemplateId: 0,
                isMetric: true,
                metricQueryName: x.queryName,
                filterEditorType: FilterEditorTypeEnum.Numeric,
                order: x.order
            }));
            
            if (activeTabOrWidget && (scope === ContainerScopeEnum.Report || scope === ContainerScopeEnum.Widget)) {
                let reportConfig = activeTabOrWidget.drilldownManager.activeReportConfig;
                if (reportConfig) {
                    let metricFields = [...reportConfig.fields().filter(x => x.isMetric)];
                    metricFields.push(...reportConfig.metricFields());
                    for (let metricField of metricFields as MetricField[]) {
                        // We don't add rank metrics as filter options. It is not supported.
                        if (metricField.metricContainer.functionType() !== FunctionTypeEnum.Rank && !data.metricFilters.find(x => x.metricQueryName === metricField.queryName)) {
                            let metric = metricField.metricContainer.isExpression ? null : data.metricFilters.find(x => x.metricQueryName === metricField.metricContainer.parentQueryName);

                            data.metricFilters.push({
                                id: metricField.queryName,
                                name: metricField.displayName(),
                                isTemplate: false,
                                filterTemplateId: 0,
                                isMetric: true,
                                metricQueryName: metricField.queryName,
                                filterEditorType: FilterEditorTypeEnum.Numeric,
                                order: metricField.metricContainer.isExpression || !metric ? 999999 : metric.order
                            });
                        }
                    }
                }
            }
        }

        filters()().forEach(function (filter: Filter) {
            if (!filter.removed()) {
                if (filter.isMetric()) {
                    data.metricFilters = data.metricFilters.filter(f => f.metricQueryName !== filter.metricQueryName());
                }
                else {
                    data.filtersTemplate = data.filtersTemplate.filter(f => f.name !== filter.filterName() && f.boundFieldId !== filter.boundField());
                }
            }
        });

        let label = `${(ContainerScopeEnum[self.scope()])}${(self.isDrilldown() ? " Drilldown" : "")}`;
        let groupedFilters = [{
            key: `${label} Filters`,
            items: data.filtersTemplate
        }];

        if (data.metricFilters && data.metricFilters.length > 0) {
            groupedFilters.push({
                key: `${label} Metric Filters`,
                items: data.metricFilters
            });
        }

        self.filtersDataSource(sortFiltersDataSource(groupedFilters));

        let popover: DevExpress.ui.dxPopover = $('.popover-add-filter', element).data("dxPopover");
        if (popover) {
            popover.beginUpdate();
            popover.option("titleTemplate", function (element) {
                titleTemplatePopover(self, element, groupedFilters);
            });
            popover.option("target", buttonElement);
            popover.endUpdate();
        }
        else {
            popover = $('.popover-add-filter', element).dxPopover({
                titleTemplate(element) {
                    titleTemplatePopover(self, element, groupedFilters);
                },
                showTitle: true,
                target: buttonElement,
                showEvent: 'dxclick',
                position: 'bottom',
                width: 300,
                height: 400,
            }).dxPopover("instance");
        }

        popover.show();
    }

    function titleTemplatePopover(self: IViewModel, element, groupedFilters) {
        const $item = $("<div>").css({ "display": "flex", "align-items": "center", "gap": "10px", "justify-content": "flex-end" });
        const $icon = $(`<i>`).addClass(self.iconClass()).html(self.icon());
        $item.append($icon);
        const $title = $("<span>").text(self.addFilterHint()).css("font-size", "14px");
        $item.append($title);
        const $button = $("<div>").dxButton({
            icon: "ms ir-sort-by-alpha-icon",
            hint: "Sort alphabetically",
            elementAttr: {
                class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
            },
            onClick(e) {
                loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                if (e.element.hasClass("selected")) {
                    e.element.removeClass("selected");
                }
                else {
                    e.element.addClass("selected");
                }

                self.filtersDataSource(sortFiltersDataSource(groupedFilters));
            }
        }).css("margin-left", "auto");
        $item.append($button);

        element.css("padding", "2px 10px");
        element.append($item);
    }

    function clearFilters(filters: KnockoutComputed<KnockoutObservableArray<Filter>>) {
        filters()().forEach(function (filter) {
            if (filter.clearFilter) {
                filter.clearFilter();
            }
        });
    }

    function sortFiltersDataSource(dataSource) {
        dataSource.forEach(item => {
            if (Array.isArray(item.items)) {
                item.items = item.items.sort(MappingService.sortFields);
            }
        });

        return dataSource;
    }
}